export default function SwapContentLoading() {
  return (
    <div className="overlay__inner">
      <div className="overlay__content">
        <span className="spinner"></span>
      </div>
    </div>
  );
}
